import { Media } from "@omni/types/api/shared/bff/media.model";
import { ProductImageRenditions } from "@omni/types/components/product/productImageRenditions.type";

import { OrderItemRenditions } from "@/components/Product/ProductImage/mappedRenditions";
import { ProductImageContainer } from "@/components/Product/ProductImage/productImage.container";
import { ConditionalWrapper } from "@/utils/helpers";

type Props = {
    url?: string | null;
    title?: string;
    medias: Array<Media> | null | undefined;
    imageRenditions?: ProductImageRenditions;
};

const OrderImage = ({ title, medias, url, imageRenditions }: Props) => {
    return (
        <ConditionalWrapper
            condition={!!url}
            wrapper={(children) => <a href={url!}>{children}</a>}
        >
            <ProductImageContainer
                title={title}
                renditions={imageRenditions || OrderItemRenditions}
                isEcoChequesAccepted={false}
                medias={medias}
            />
        </ConditionalWrapper>
    );
};

export { OrderImage };
